// Copyright (C) 2024 Cloudflare Configuration for Stremio Web

// Cloudflare torrent optimizer configuration
const CLOUDFLARE_TORRENT_OPTIMIZERS = [
    'https://torrentio.strem.fun/', // Official Torrentio (frequent downtime)
    'https://comet.elfhosted.com/', // Comet - reliable alternative
    'https://mediafusion.elfhosted.com/', // MediaFusion - good alternative
    'https://annatar.elfhosted.com/', // Annatar - another alternative
    'https://jackettio.elfhosted.com/', // Jackettio - Jackett-based
    'https://orionoid.com/', // Orion - premium option
    'https://stremthru.elfhosted.com/' // StremThru - newer option
];

// Default Cloudflare optimizer (using most reliable alternative)
const DEFAULT_CLOUDFLARE_OPTIMIZER = 'https://comet.elfhosted.com/';

// Detect if running in Cloudflare Pages environment
const isCloudflareEnvironment = () => {
    try {
        // Check for Cloudflare-specific environment variables or headers
        return (
            // Check if we're in a Cloudflare Worker environment
            (typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope) ||
            // Check for Cloudflare Pages deployment
            (typeof window !== 'undefined' && window.location && 
             (window.location.hostname.includes('pages.dev') || 
              window.location.hostname.includes('cloudflare') ||
              // Check for common Cloudflare deployment patterns
              (document && document.referrer && document.referrer.includes('cloudflare')) ||
              // Check if we're serving from Cloudflare CDN
              (window.location.origin && window.location.origin.includes('cloudflare')))) ||
            // Check for Cloudflare-specific headers (in Node.js environment)
            (typeof process !== 'undefined' && process.env && 
             (process.env.CF_PAGES === '1' || process.env.CLOUDFLARE_PAGES === 'true'))
        );
    } catch (error) {
        console.log('Error detecting Cloudflare environment:', error);
        return false;
    }
};

// For immediate detection during module loading, use a simpler check
const detectCloudflareImmediate = () => {
    try {
        // Simple check for pages.dev domain (most common Cloudflare Pages pattern)
        if (typeof window !== 'undefined' && window.location && window.location.hostname) {
            return window.location.hostname.includes('pages.dev');
        }
        // Check Node.js environment
        if (typeof process !== 'undefined' && process.env) {
            return process.env.CF_PAGES === '1' || process.env.CLOUDFLARE_PAGES === 'true';
        }
        return false;
    } catch (error) {
        return false;
    }
};

// Configuration for browser-based streaming
const BROWSER_CONFIG = {
    // Use Cloudflare Workers for torrent processing
    useCloudflareWorkers: true,
    
    // Enable direct browser streaming - disable for cloud-only deployments
    enableBrowserStreaming: !detectCloudflareImmediate(),
    
    // Disable local server dependency
    disableLocalServer: true,
    
    // Use HTTPS for all requests
    forceHTTPS: true,
    
    // Cache settings for Cloudflare
    cacheSettings: {
        enableCaching: true,
        cacheDuration: 3600, // 1 hour
        maxCacheSize: 100 * 1024 * 1024 // 100MB
    },
    
    // Streaming configuration
    streaming: {
        // Use WebRTC for peer-to-peer connections
        useWebRTC: true,
        
        // Enable Media Source Extensions (MSE)
        useMSE: true,
        
        // Buffer settings
        bufferSize: 10 * 1024 * 1024, // 10MB
        bufferTime: 30, // 30 seconds
        
        // Quality settings
        maxQuality: '1080p',
        preferredQuality: '720p'
    }
};

// Export configuration
module.exports = {
    CLOUDFLARE_TORRENT_OPTIMIZERS,
    DEFAULT_CLOUDFLARE_OPTIMIZER,
    BROWSER_CONFIG
};